import { get } from 'lodash'
import { required, ageBetween, maxLength, phone, requiredPhone } from 'utils/validation'


const validate = (values, props) => {
  let errors = {}

  const awardConfigurations = get(
    values,
    'helpers.awardLevelConfigurations',
    []
  )

  errors = {
    firstName:
      required(get(values, 'firstName')) ||
      maxLength(50)(get(values, 'firstName')),
    lastName:
      required(get(values, 'lastName')) ||
      maxLength(50)(get(values, 'lastName')),
    middleName: maxLength(50)(get(values, 'middleName')),
    birthDate:
      required(get(values, 'birthDate')) ||
      ageBetween(get(values, 'birthDate'), get(values, 'awardLevel.value'), {
        configuration: get(props, 'configuration.values'),
        awardConfigurations
      }),
    gender: {
      value: required(get(values, 'gender.value'))
    },
    nationality: {
      value: required(get(values, 'nationality.value'))
    },
    employmentStatus: {
      value: required(get(values, 'employmentStatus.value'))
    },
    line1:
      required(get(values, 'line1')) || maxLength(500)(get(values, 'line1')),
    line2: maxLength(255)(get(values, 'line2')),
    zipCode:
      required(get(values, 'zipCode')) || maxLength(20)(get(values, 'zipCode')),
    city: required(get(values, 'city')) || maxLength(50)(get(values, 'city')),
    addressCountryId: required(get(values, 'addressCountryId')),
    stateOrProvinceOrRegion:
      required(get(values, 'stateOrProvinceOrRegion')) ||
      maxLength(70)(get(values, 'stateOrProvinceOrRegion')),
    phoneNumber:
      requiredPhone(get(values, 'phoneNumber')) ||
      phone(get(values, 'phoneNumber')),
  }

  if (get(values, 'helpers.previousCompletedAward.value') === 'yes') {
    const prevLevel = get(values, 'previousCompletedAwardLevel.value')

    errors = {
      ...errors,
      previousCompletedAwardPlace: required(
        get(values, 'previousCompletedAwardPlace')
      ),
      previousCompletedAwardLevel: {
        value: required(prevLevel === 'no' ? undefined : prevLevel)
      }
    }
  }

  if (get(values, 'helpers.postalAddressChecked')) {
    errors = {
      ...errors,
      postal: {
        addressCountryId: required(get(values, 'postal.addressCountryId')),
        line1:
          required(get(values, 'postal.line1')) ||
          maxLength(500)(get(values, 'postal.line1')),
        line2: maxLength(255)(get(values, 'postal.line2')),
        zipCode:
          required(get(values, 'postal.zipCode')) ||
          maxLength(20)(get(values, 'postal.zipCode')),
        city:
          required(get(values, 'postal.city')) ||
          maxLength(50)(get(values, 'postal.city')),
        stateOrProvinceOrRegion:
          required(get(values, 'postal.stateOrProvinceOrRegion')) ||
          maxLength(70)(get(values, 'postal.stateOrProvinceOrRegion'))
      }
    }
  }

  return errors
}

export default validate
